var exports = {
  "vL": "assigneeItem__luUQei",
  "z3": "assigneeName__dvYCUT",
  "Ev": "SessionIndicator__LVZqBB",
  "UD": "SessionSpinner__CaqSEL",
  "c0": "StatusCritical__dSQkUR",
  "ly": "StatusWarning__uy3cMq",
  "yL": "StatusSuccess__Zcjgai",
  "Tm": "StatusDetails__ZyBimv",
};

module.exports = exports;
